import React from 'react';

function TextAreaEditor(props) {

    if (typeof(props.id) != 'string') {
        throw new TypeError("Required ID prop has not been set")
    }

    const onEditorChange = (e) => {
        // Bubble the event up to the calling component
        if (props.onChange) {
            props.onChange({ originalEvent: e, value: e.target.value, props: props });
        }
    }

    return (
        (props.naked ?
            <textarea className="" value={props.value || ""} onChange={onEditorChange} rows={props.rows}></textarea>
        :
            <td className={props.className || "control"} colSpan={props.colSpan}>
                <textarea className="" value={props.value || ""} onChange={onEditorChange} rows={props.rows}></textarea>
            </td>
        )
    )
}

export default TextAreaEditor;